import type { ChargedAttack } from '../../../data/full/attacks';
import { angleOf } from '../../../shared/angle';
import { fireShot } from '../../attacks/shot';
import { pullTrigger } from '../../attacks/trigger';
import type { AttackModule } from '../../attacks/types';
import { statValue } from '../../stats';

// Let go before the cooldown allows, the shot leaves as soon as it does.
export const charged: AttackModule<ChargedAttack> = {
  reads: ['attackCooldownMul', 'damageMul', 'pierceAdd', 'projectileSpeedMul'],

  step({ state }, player, attack, input) {
    if (input.fire) {
      const counted = input.fireTicks ?? (player.chargeTicks ?? 0) + 1;
      player.chargeTicks = Math.min(attack.chargeTicks, counted);
    }
    const held = player.chargeTicks;
    const pulled = pullTrigger(player, !input.fire && held !== undefined, attack.cooldownTicks);
    if (!pulled || held === undefined) {
      return;
    }
    delete player.chargeTicks;
    const charge = held / attack.chargeTicks;
    fireShot(state, player, player.aim, {
      speed: statValue(player, 'projectileSpeedMul', attack.projectileSpeed),
      radius: attack.projectileRadius,
      damage: statValue(
        player,
        'damageMul',
        attack.damage + (attack.fullDamage - attack.damage) * charge,
      ),
      ticks: attack.rangeTicks,
      pierce: statValue(
        player,
        'pierceAdd',
        Math.floor(attack.pierce + (attack.fullPierce - attack.pierce) * charge),
      ),
    });
    state.events.push({
      type: 'playerFired',
      playerId: player.id,
      x: player.x,
      y: player.y,
      angle: angleOf(player.aim),
    });
  },

  reach(attack, player) {
    return statValue(player, 'projectileSpeedMul', attack.projectileSpeed) * attack.rangeTicks;
  },

  chargeTicks(attack) {
    return attack.chargeTicks;
  },
};
